import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "../ui/sheet";

export default function AdminLayout() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <div className="min-h-screen bg-slate-50 lg:flex">
            <Sidebar />
            <header className="sticky top-0 z-40 flex h-16 items-center gap-3 border-b border-slate-200 bg-white px-4 lg:hidden">
                <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
                    <SheetTrigger asChild>
                        <button
                            type="button"
                            aria-label="Ouvrir le menu de navigation"
                            className="inline-flex h-11 w-11 items-center justify-center rounded-md text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-orange-500"
                        >
                            <Menu className="h-6 w-6" />
                        </button>
                    </SheetTrigger>
                    <SheetContent side="left" className="w-[min(20rem,88vw)] border-0 bg-slate-900 p-0 text-slate-300">
                        <SheetTitle className="sr-only">Navigation ASSMBB</SheetTitle>
                        <Sidebar mobile onNavigate={() => setMobileMenuOpen(false)} />
                    </SheetContent>
                </Sheet>
                <img
                    src="https://res.cloudinary.com/dswtir2fh/image/upload/logo_hampwx"
                    alt="ASSMBB"
                    className="h-10 w-10 rounded-lg bg-white object-contain p-1"
                />
                <div className="min-w-0">
                    <div className="truncate font-display font-bold text-slate-900">Mada Sport Club Manager</div>
                    <div className="text-[10px] uppercase tracking-widest text-slate-500">ASSMBB</div>
                </div>
            </header>
            <main className="flex-1 min-w-0">
                <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
